export const ORGANIZAR_ATUALIZAR_LOTE_LAMINAS = 'ORGANIZAR_ATUALIZAR_LOTE_LAMINAS';
export const atualizarLamina = (laminas) => ({
  type: ORGANIZAR_ATUALIZAR_LOTE_LAMINAS,
  payload: {
    laminas,
  },
});
export const ORGANIZAR_ATUALIZAR_MOVER_DISABLED = 'ORGANIZAR_ATUALIZAR_MOVER_DISABLED';
export const atualizarMoverDisabled = (moverDisabled) => ({
  type: ORGANIZAR_ATUALIZAR_MOVER_DISABLED,
  payload: {
    moverDisabled,
  },
});
export const ORGANIZAR_ATUALIZAR_MODAL = 'ORGANIZAR_ATUALIZAR_MODAL';
export const atualizarModal = (modal) => ({
  type: ORGANIZAR_ATUALIZAR_MODAL,
  payload: {
    modal,
  },
});
export const ORGANIZAR_ATUALIZAR_NOVAS_LAMINAS = 'ORGANIZAR_ATUALIZAR_NOVAS_LAMINAS';
export const atualizarNovasLaminas = (novasLaminas) => ({
  type: ORGANIZAR_ATUALIZAR_NOVAS_LAMINAS,
  payload: {
    novasLaminas,
  },
});
export const ORGANIZAR_ATUALIZAR_DESTINOS = 'ORGANIZAR_ATUALIZAR_DESTINOS';
export const atualizarDestinos = (destinos) => ({
  type: ORGANIZAR_ATUALIZAR_DESTINOS,
  payload: {
    destinos,
  },
});

export const ORGANIZAR_ATUALIZAR_LISTA = 'ORGANIZAR_ATUALIZAR_LISTA';
export const atualizarLista = (lista) => ({
  type: ORGANIZAR_ATUALIZAR_LISTA,
  payload: {
    lista,
  },
})


// WEBPACK FOOTER //
// ./src/componentes/dragdrog/organizarLote/store/organizar.action.js